import { jwtDecode } from "jwt-decode";

type JwtPayload = {
  sub?: string;
  email?: string;
  exp?: number;
  [key: string]: unknown;
};

/**
 * Decode a JWT token and return its payload.
 * @param token - The JWT token string to decode
 * @returns The decoded JWT payload
 */
export const decodeJwtPayload = (token: string): JwtPayload => {
  return jwtDecode<JwtPayload>(token);
};
